import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import selectBranchByBrandApi from "../api/checkListedItemApi";
import {
  findBranches,
  setBranchId,
} from "../../../modules/reducers/getBranches/getBranches";
import { useLocation, useNavigate } from "react-router-dom";
import { haversine } from "../../../utils";
import { brandIdMap } from "../../Search/const/brandIdMap";
import { getQuickMenu } from "../../../modules/reducers/landing/quickMenu";
import { quickMenuApi } from "../../../api/quickMenu/quickMenuApi";
import { initDestination } from "../../../modules/reducers/destination/destination";
import { getValidatedExternalUrl } from "#src/utils/validateExternalUrl.js";

const useSelectBranch = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const allbranches = useSelector((state) => state.getBranches.branchList);
  const brandId = useSelector((state) => state.checkArsStatus.brandId);
  const tempUserId = useSelector((state) => state.checkArsStatus.userId);
  const userId = tempUserId??"".replaceAll(" ", "+");
  const menuItems = useSelector((state) => state.quickMenu.menuItems);
  const label = useSelector((state) => state.destination.label);
  const predefinedDestination = ["/search"];

  const [keyword, setKeyword] = useState("");
  const [branch, setBranch] = useState("");
  const [branchList, setBranchList] = useState([]);
  const [branchListWithDistance, setBranchListWithDistance] = useState([]);
  const [location, setLocation] = useState({
    // 내 위치
    lat1: 0,
    lng1: 0,
  });
  const [move2Next, setMove2Next] = useState(false);
  const [pendingExternalUrl, setPendingExternalUrl] = useState(null);
  const { state } = useLocation();
  const handleInputChange = (event) => {
    setKeyword(event.target.value);
  };

  const handleClearClick = () => {
    setKeyword("");
    setBranch("");
  };

  const filterList = (keyword) => {
    const lowercasedKeyword = keyword.toLowerCase();
    const newList = allbranches?.filter(
      (item) =>
        item.name.toLowerCase().includes(lowercasedKeyword) ||
        item.areaName.toLowerCase().includes(lowercasedKeyword) ||
        item.address.toLowerCase().includes(lowercasedKeyword)
    );
    if (newList.length == 0) {
      setBranchList(allbranches);
    } else {
      setBranchList(newList);
    }
  };

  const search = () => {
    filterList(keyword);
  };

  const selectBranch = (id) => {
    if (!id) {
      console.warn("selectBranch called with invalid id:", id);
      return;
    }
    const branch = branchList.find((item) => item.id === id);
    if (!branch) {
      console.warn("Branch not found for id:", id);
      return;
    }
    setBranch(branch);
    dispatch(
      setBranchId({
        selectedBranchId: id,
        tel: branch?.tel || "",
        area: branch?.area || "",
        selectedBranchName: branch?.name || "",
      })
    );
  };

  const moveToDestination = (id = null) => {
    if (branch === "") {
    } else {
      if (id !== null) {
        const api = quickMenuApi();
        const brandCd = brandIdMap[brandId]?.cd || null;
        const data = { user_id: userId, biztp: brandCd, store_id: id };
        setMove2Next(true);
        dispatch(getQuickMenu({ ...api, data }));
        // dispatch(setBranchId({ selectedBranchId: id }));
      }
    }
  };

  useEffect(() => {
    const destination = menuItems?.find((item) => item.label === label);

    if (move2Next) {
      if (predefinedDestination.includes(destination?.value)) {
        dispatch(initDestination());

        const externalHref = getValidatedExternalUrl(destination?.value);
        if (externalHref) {
          setPendingExternalUrl(externalHref);
        } else {
          navigate(destination?.value);
        }
      } else {
        navigate("/landing");
      }
      setMove2Next(false);
    }

  }, [menuItems, move2Next, label, dispatch, navigate]);

  useEffect(() => {
    const branchesWithDistance =
      location.lat1 !== 0 && location.lng1 !== 0
        ? branchList
            .map((branch) => {
              // 각 지점을 복사하여 distance 속성 추가
              return {
                ...branch,
                distance: haversine(location, {
                  lat2: branch.map_x,
                  lng2: branch.map_y,
                }),
              };
            })
            .slice()
            .sort((a, b) => a.distance - b.distance) // 거리 기준으로 정렬
        : branchList;
    setBranchListWithDistance(branchesWithDistance);
  }, [branchList, location]);

  useEffect(() => {
    const api = selectBranchByBrandApi(brandId);
    dispatch(findBranches(api));
  }, []);

  useEffect(() => {
    search();
  }, [keyword, allbranches]);

  const clearPendingExternalUrl = () => {
    setPendingExternalUrl(null);
  };

  return {
    keyword,
    handleInputChange,
    handleClearClick,
    search,
    selectBranch,
    moveToDestination,
    branch,
    setKeyword,
    location,
    setLocation,
    branchListWithDistance,
    pendingExternalUrl,
    clearPendingExternalUrl,
  };
};

export default useSelectBranch;
